import { Asterisk } from "lucide-react";
import { MARQUEE } from "../data/content";

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-neon/10 bg-coal py-5" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {MARQUEE.map((phrase) => (
              <span key={`${copy}-${phrase}`} className="flex items-center">
                <span className="mx-8 whitespace-nowrap font-serif text-xl italic text-cream/35 sm:text-2xl">
                  {phrase}
                </span>
                <Asterisk size={18} className="shrink-0 text-neon/50" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
